import InfoTokenProvider from './InfoTokenProvider'
import ObjectTokenProvider from './ObjectTokenProvider'
import DataTypeTokenProvider from './DataTypeTokenProvider'

var RESOLVE_TYPE_TEXT = 0;
var RESOLVE_TYPE_RICH_TEXT = 1;
var RESOLVE_TYPE_HTML = 2;

var DYNAMIC_TOKENS = /(\$\{([a-zA-Z0-9_]+)(\.([a-zA-Z0-9_]+))?(="?(.*?)"?)?\})/gi;
var STATIC_TOKENS = /(\$\[([a-zA-Z0-9_]+)(\.([a-zA-Z0-9_]+))?(="?(.*?)"?)?\])/gi;

var TokenResolver = {

    registerTokenProviders: function() {
        this._providers = {};
        this.registerTokenProvider(new InfoTokenProvider());
        this.registerTokenProvider(new ObjectTokenProvider());
        this.registerTokenProvider(new DataTypeTokenProvider());
    },

    registerTokenProvider: function(provider) {
        var tokens = provider.getSupportedTokens();
        for (var i = 0; i < tokens.length; i++) {
            this._providers[tokens[i]] = provider;
        }
    },

    getTokenProvider: function(token) {
        if (!this._providers) {
            this.registerTokenProviders();
        }
        if (this._providers[token]) {
            return this._providers[token];
        }
        return null;
    },

    resolveToken: function(mapObject, token, field, defaultValue, resolveType) {

        var provider = this.getTokenProvider(token);
        if (provider != null) {
            switch (resolveType) {
                case RESOLVE_TYPE_TEXT:
                    return provider.resolveTextToken(mapObject, token, field, defaultValue);
                case RESOLVE_TYPE_RICH_TEXT:
                    return provider.resolveRichTextToken(mapObject, token, field, defaultValue);
                case RESOLVE_TYPE_HTML:
                    return provider.resolveHTMLToken(mapObject, token, field, defaultValue);
                default:
                    break;
            }
        }
        return defaultValue;
    },

    resolveTokensByType: function(mapObject, string, tokensRegEx, resolveType) {
        var self = this;
        var stringToUse = string && typeof(string) == "string" ? string : "";
        var result = stringToUse.replace(tokensRegEx,
            function(a, b, token, c, field, d, defaultValue) {
                var r = self.resolveToken(mapObject, token, field, defaultValue, resolveType);
                if (typeof r === 'undefined') {
                    r = "";
                }
                return r;
            }
        );
        return result;
    },

    resolveHTMLDynamicTokens: function(mapObject, string) {
        return this.resolveTokensByType(mapObject, string, DYNAMIC_TOKENS, RESOLVE_TYPE_HTML);
    },

    resolveRichTextDynamicTokens: function(mapObject, string) {
        return this.resolveTokensByType(mapObject, string, DYNAMIC_TOKENS, RESOLVE_TYPE_RICH_TEXT);
    },

    resolveTextDynamicTokens: function(mapObject, string) {
        return this.resolveTokensByType(mapObject, string, DYNAMIC_TOKENS, RESOLVE_TYPE_TEXT);
    },

    resolveHTMLStaticTokens: function(mapObject, string) {
        return this.resolveTokensByType(mapObject, string, STATIC_TOKENS, RESOLVE_TYPE_HTML);
    },

    resolveRichTextStaticTokens: function(mapObject, string) {
        return this.resolveTokensByType(mapObject, string, STATIC_TOKENS, RESOLVE_TYPE_RICH_TEXT);
    },

    resolveTextStaticTokens: function(mapObject, string) {
        return this.resolveTokensByType(mapObject, string, STATIC_TOKENS, RESOLVE_TYPE_TEXT);
    },

    resolveHTMLTokens: function(mapObject, string) {
        return this.resolveHTMLDynamicTokens(mapObject, this.resolveHTMLStaticTokens(mapObject, string));
    },

    resolveRichTextTokens: function(mapObject, string) {
        return this.resolveRichTextDynamicTokens(mapObject, this.resolveRichTextStaticTokens(mapObject, string));
    },

    resolveTextTokens: function(mapObject, string) {
        return this.resolveTextDynamicTokens(mapObject, this.resolveTextStaticTokens(mapObject, string));
    }
};

export default TokenResolver;